import Controller from '@ember/controller';
import type { ModelType } from 'codecrafters-frontend/routes/vote';

export default class VoteController extends Controller {
  declare model: ModelType;
}
